import * as React from 'react';
import S from './Form.styles';
const FormField = ({ showLabel = true, ...otherProps }) => {
    const errorToShow = Array.isArray(otherProps.error)
        ? otherProps.error.find((error) => !!error)
        : otherProps.error;
    const name = Array.isArray(otherProps.name) ? otherProps.name[0] : otherProps.name;
    return (React.createElement(S.Field, { "data-size": otherProps.size ?? 'default', "data-error": !!errorToShow },
        otherProps.label && (React.createElement(S.Label, { "data-move-label": otherProps.moveLabel, htmlFor: name, "data-hide": !showLabel, "data-required": otherProps.required }, otherProps.label)),
        otherProps.children,
        otherProps.description && (React.createElement(S.Description, { dangerouslySetInnerHTML: { __html: otherProps.description } })),
        errorToShow && React.createElement(S.Error, null, errorToShow.message)));
};
export default FormField;
